import styles from "./DesignBoxNavigationCrumb.module.css";
const DesignBoxNavigationCrumb = ({
  active,
  active5 = "#E1E9F2",
  inactive5 = "#DFE1E3",
  showFifth,
  fourthText,
}) => {
  return (
    <>
      <div className={styles.navigation_crumb_main_div}>
        <button
          style={{
            backgroundColor: active === 1 ? "#E1E9F2" : "#DFE1E3",
            color: active === 1 ? "#272727" : "rgba(0, 0, 0, 0.318)",
          }}
        >
          アイテム選択
        </button>
        <span
          style={{ opacity: active >= 1 ? "100%" : "60%" }}
          className={`material-icons ${styles.right_arrow}`}
        >
          keyboard_arrow_right
        </span>
        <button
          style={{
            backgroundColor: active === 2 ? "#E1E9F2" : "#DFE1E3",
            color: active === 2 ? "#272727" : "rgba(0, 0, 0, 0.318)",
          }}
        >
          決　済
        </button>
        <span
          style={{ opacity: active >= 2 ? "100%" : "60%" }}
          className={`material-icons ${styles.right_arrow}`}
        >
          keyboard_arrow_right
        </span>
        <button
          style={{
            backgroundColor: active === 3 ? "#E1E9F2" : "#DFE1E3",
            color: active === 3 ? "#272727" : "rgba(0, 0, 0, 0.318)",
          }}
        >
          デザイン編集
        </button>
        <span
          style={{ opacity: active >= 3 ? "100%" : "60%" }}
          className={`material-icons ${styles.right_arrow}`}
        >
          keyboard_arrow_right
        </span>
        <button
          style={{
            backgroundColor: active === 4 ? "#E1E9F2" : "#DFE1E3",
            color: active === 4 ? "#272727" : "rgba(0, 0, 0, 0.318)",
          }}
        >
          {fourthText ? fourthText : "完了"}
        </button>
        {showFifth && (
          <>
            <span
              style={{ opacity: active >= 4 ? "100%" : "60%" }}
              className={`material-icons ${styles.right_arrow}`}
            >
              keyboard_arrow_right
            </span>
            <button
              style={{
                backgroundColor: active === 5 ? active5 : inactive5,
                color: active === 5 ? "#272727" : "rgba(0, 0, 0, 0.318)",
              }}
            >
              完成データ確認
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default DesignBoxNavigationCrumb;
